/*
  Offer box: tier fetch, cart add, carousel, accordion, counter, sticky bar.

  Moved out of sections/brewzle-offer.liquid on 2026-09-21. It was inline, so it ran during
  parse and held up first paint: Lighthouse put 1,841ms of main thread on the
  document itself, and the hero photo, already downloaded by ~480ms, was waiting
  on it. Loaded with defer instead, which runs after the document is parsed.

  The code is unchanged apart from the root lookup. It used to interpolate the
  section id into a class selector; it now finds the same element by the
  data-bz-section attribute the section already carries.
*/
(function () {
    // Scoped per instance, the way the inline version was: it keyed on its own
    // section id, so a second copy of this section on a page got its own
    // behaviour. A bare querySelector would have bound only the first. One
    // instance per page on templates/page.brewzle.json today; this does not
    // rely on that staying true.
    var bzRoots = document.querySelectorAll('[data-bz-section="offer"]');
    for (var bzIndex = 0; bzIndex < bzRoots.length; bzIndex++) initBrewzleOffer(bzRoots[bzIndex]);

    function initBrewzleOffer(root) {

    var cta = root.querySelector('[data-bz-cta="checkout"]');
    var ctaLabel = root.querySelector('[data-bz-cta-label]');
    var ctaError = root.querySelector('[data-bz-cta-error]');
    var ctaStatus = root.querySelector('[data-bz-cta-status]');
    var ctaSoldout = root.querySelector('[data-bz-cta-soldout]');
    var form = root.querySelector('form[data-bz-offer-form="true"]');
    var originalLabel = ctaLabel ? ctaLabel.innerHTML : '';

    // Analytics hook: the funnel script (owned by a different builder) listens for
    // these on document and turns them into brewzle_* PostHog events. This script
    // runs before the deferred analytics bundle, so the current state also sits
    // on data-bz-state for a late listener to read.
    function announce(name, detail) {
      try {
        root.dispatchEvent(new CustomEvent('bz-offer:' + name, { bubbles: true, detail: detail || {} }));
      } catch (e) { /* CustomEvent unsupported: analytics only */ }
    }

    /* ---------- State: healthy / low / sold-out ---------- */
    function setBlockedState(kind) {
      // kind: 'sold-out' | null (open). No expired/wait-list state on this
      // page: the offer has no count-down timer.
      var state = kind || 'open';
      if (root.getAttribute('data-bz-state') !== state) {
        root.setAttribute('data-bz-state', state);
        announce('state', { state: state });
      }
      if (kind) {
        if (form) form.hidden = true;
        else if (cta) cta.hidden = true;
        if (ctaSoldout) ctaSoldout.hidden = false;
      } else {
        if (form) form.hidden = false;
        else if (cta) cta.hidden = false;
        if (ctaSoldout) ctaSoldout.hidden = true;
      }
    }

    /* ---------- Bottles-left counter (the feed sends claimed; the card shows what is left) ---------- */
    var limit = Number(root.getAttribute('data-spots-limit')) || 0;
    var claimed = Number(root.getAttribute('data-spots-claimed')) || 0;
    var low = Number(root.getAttribute('data-spots-low')) || 0;
    var counter = root.querySelector('[data-bz-counter]');
    var skipFillTransition = false;

    function spotsLeftShown() {
      return Math.max(0, limit - claimed);
    }

    function formatCount(n) {
      var s = String(Math.max(0, Math.floor(n)));
      return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function renderCounter() {
      claimed = Math.max(0, Math.min(limit, claimed));
      var left = spotsLeftShown();
      var pct = limit > 0 ? Math.round((left / limit) * 10000) / 100 : 0;
      var state = left <= 0 ? 'sold-out' : left <= low ? 'low' : 'healthy';
      root.setAttribute('data-state', state);

      // The announcement bar and the sticky pill carry the same spans, so one
      // render keeps every number on the page in step (exact counts, with a
      // thousands separator, per Harpawan's 2026-09-17 call).
      document.querySelectorAll('[data-bz-spots-left]').forEach(function (el) {
        el.textContent = formatCount(left);
      });
      document.querySelectorAll('[data-bz-spots-limit]').forEach(function (el) {
        el.textContent = formatCount(limit);
      });
      if (counter) {
        var countEl = counter.querySelector('[data-bz-count]');
        var limitEl = counter.querySelector('[data-bz-limit]');
        var fill = counter.querySelector('[data-bz-counter-fill]');
        var bar = counter.querySelector('[role="progressbar"]');
        var copy = counter.querySelector('[data-bz-counter-copy]');
        var leftPercent = counter.querySelector('[data-bz-left-percent]');
        var soldOut = counter.querySelector('[data-bz-counter-soldout]');
        if (countEl) countEl.textContent = formatCount(left);
        if (limitEl) limitEl.textContent = formatCount(limit);
        if (fill) {
          // The first render from the feed replaces the placeholder: snap, do not animate.
          if (skipFillTransition) {
            fill.style.transition = 'none';
            fill.style.width = pct + '%';
            void fill.offsetWidth;
            fill.style.transition = '';
            skipFillTransition = false;
          } else {
            fill.style.width = pct + '%';
          }
        }
        if (bar) {
          bar.setAttribute('aria-valuemax', String(limit));
          bar.setAttribute('aria-valuenow', String(left));
          bar.setAttribute('aria-valuetext', left + ' of ' + limit + ' left');
        }
        // Floored, so the line never reads 100% once a bottle has gone; 1% while any are left.
        if (leftPercent) leftPercent.textContent = String(limit > 0 && left > 0 ? Math.max(1, Math.floor((left / limit) * 100)) : 0);
        if (copy) copy.hidden = state === 'sold-out';
        if (soldOut) soldOut.hidden = state !== 'sold-out';
      }
      setBlockedState(state === 'sold-out' ? 'sold-out' : null);
    }

    function pickNumber(obj, keys) {
      for (var i = 0; i < keys.length; i++) {
        var v = obj[keys[i]];
        if (typeof v === 'number' && isFinite(v)) return v;
        if (typeof v === 'string' && v.trim() !== '' && isFinite(Number(v))) return Number(v);
      }
      return null;
    }

    function loadSpotsFeed() {
      var url = root.getAttribute('data-spots-feed');
      if (!url) return;
      fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('spots feed ' + res.status)); })
        .then(function (json) {
          var data = json && json.data && typeof json.data === 'object' ? json.data : json;
          if (!data || typeof data !== 'object') return;
          var c = pickNumber(data, ['claimed', 'sold', 'count', 'boxes']);
          var l = pickNumber(data, ['limit', 'cap', 'total']);
          if (c !== null) claimed = Math.max(0, Math.floor(c));
          if (l !== null && l > 0) limit = Math.floor(l);
          // Stock the feed can stand behind wins over the editor's limit: stockLeft is the
          // available units across the pinned collection minus sold boxes not built yet, so
          // the total (left + claimed) rises by itself when reserve stock is released. A
          // truncated order scan reports 0 it cannot stand behind, and an unread collection
          // reports null; both keep the editor's limit.
          var s = pickNumber(data, ['stockLeft']);
          if (s !== null && s >= 0 && data.stockScanComplete !== false && s + claimed > 0) {
            limit = Math.floor(s) + claimed;
          }
          skipFillTransition = true;
          renderCounter();
        })
        .catch(function (err) {
          // The settings values stay on screen; a feed blip must not blank the counter.
          if (window.console) console.warn('[Brewzle offer] spots feed unavailable:', err && err.message);
        });
    }

    renderCounter();
    loadSpotsFeed();

    /* ---------- Add to cart: tier items from the backend, atomic add ---------- */
    function getApiBase() {
      var base = root.getAttribute('data-api-base') || (typeof window !== 'undefined' ? window.__QUIZ_API_BASE__ : '') || '';
      return String(base).replace(/\/$/, '');
    }

    function normalizeTierEntry(entry) {
      var e = entry && typeof entry === 'object' ? entry : {};
      var rawItems = Array.isArray(e.items) ? e.items : [];
      return rawItems
        .map(function (obj) {
          var i = obj && typeof obj === 'object' ? obj : {};
          var variant = '';
          if (typeof i.variant === 'number' && isFinite(i.variant)) variant = String(Math.trunc(i.variant));
          else if (typeof i.variant === 'string') variant = i.variant.trim();
          var quantity = isFinite(Number(i.quantity)) ? Number(i.quantity) : 0;
          var sellingPlan = '';
          if (typeof i.sellingPlan === 'number' && isFinite(i.sellingPlan)) sellingPlan = String(Math.trunc(i.sellingPlan));
          else if (typeof i.sellingPlan === 'string') sellingPlan = i.sellingPlan.trim();
          var properties = i.properties && typeof i.properties === 'object' ? i.properties : null;
          var role = typeof i._role === 'string' ? i._role.trim() : '';
          if (!variant || quantity <= 0) return null;
          var item = { id: variant, quantity: quantity };
          if (sellingPlan) item.selling_plan = Number(sellingPlan) || sellingPlan;
          if (properties) item.properties = properties;
          if (role) item._role = role;
          var fdRaw = i.flatDiscount;
          if (fdRaw != null && fdRaw !== '') {
            var fdNum = Number(fdRaw);
            item.flatDiscount = isFinite(fdNum) ? fdNum : String(fdRaw).trim();
          }
          return item;
        })
        .filter(Boolean);
    }

    async function fetchTierItems() {
      var base = getApiBase();
      if (!base) throw new Error('Quiz API base URL is not set');
      var key = root.getAttribute('data-tier-key') || 'pdp-explorer';
      var res = await fetch(base + '/api/tiers', { method: 'GET', headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('Tier API error: ' + res.status);
      var json = await res.json();
      var tiers = (json && json.data && json.data.tiers) || (json && json.tiers) || null;
      var tier = tiers && tiers[key] ? tiers[key] : null;
      var items = normalizeTierEntry(tier);
      if (!items.length) throw new Error('Tier payload missing ' + key + ' items');
      return items;
    }

    // Fallback when the shared add script is missing. The token on the fetch and on
    // the error is what keeps the failure to one report (see cart-failure-reporter.js).
    async function addItemsToCart(items, reportToken) {
      reportToken = reportToken || {};
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
        wlReportToken: reportToken,
      });
      if (!res.ok) {
        var text = '';
        try { text = await res.text(); } catch (e) {}
        var err = new Error('Cart add failed: ' + res.status + (text ? ' ' + text : ''));
        err.stage = 'cart_add';
        err.http_status = res.status;
        err.cart_endpoint = '/cart/add.js';
        err._reportToken = reportToken;
        throw err;
      }
      return res.json().catch(function () { return null; });
    }

    // Marker for the offer on every line, for the Shopify Flow that tags the order
    // and the customer brewzle-offer. Since Labor Day's 2026-09-12 correction it is
    // ALSO stamped as a cart attribute right after the add (Bhuvi: Recharge does not
    // carry line item properties onto recurring orders, order attributes it does,
    // order #54945), so renewal orders keep the marker. Known trade-off: cart
    // attributes outlive the box (they survive the drawer's remove and
    // /cart/clear.js), so a shopper who drops the box and buys a bottle still
    // carries the attribute. The stamp is awaited after the add (never in parallel:
    // that race lost the milestone tag on half the taste-profile orders), inside an
    // 8s budget, and a failed stamp does not undo the add. See CLAUDE.md.
    var OFFER_PROGRAM = root.getAttribute('data-offer-program') || 'brewzle-offer';
    var OFFER_SOURCE = root.getAttribute('data-offer-source') || 'brewzle_offer';
    var PINNED_COLLECTION = (root.getAttribute('data-pinned-collection') || 'brewzles-pick').trim();
    var OFFER_ATTRIBUTE_KEY = '_offerProgram';
    // Same markers taste-profile / PDP upsell stamp — months 2/3 gifts use the existing
    // three-month-milestone Offers row (no Brewzle-specific Offers config).
    var MILESTONE_PROGRAM = '3-month-milestone';
    var MILESTONE_TIER = 'explorer';

    // Order-level copy of the markers, for Recharge renewals. One /cart/update.js with a
    // retry; the shopper still holds the loading button, so the stamp lands before checkout.
    var ATTRIBUTE_DEADLINE_MS = 8000;

    async function stampOfferAttribute(bundleId) {
      var attrs = {};
      attrs[OFFER_ATTRIBUTE_KEY] = OFFER_PROGRAM;
      // Milestone gifts (shared with taste-profile) — set, do not blank. Labor Day blanks
      // these so a prior taste-profile session cannot leak onto that page; Brewzle IS on
      // the milestone program for months 2/3.
      attrs._milestoneProgram = MILESTONE_PROGRAM;
      attrs._milestoneTier = MILESTONE_TIER;
      // A taste profile visit's Starter test arm must not ride onto this order.
      attrs._starterTierTest = '';
      var cart = await cartFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }, 'cart_attributes', 1);
      var stored = cart && cart.attributes ? cart.attributes[OFFER_ATTRIBUTE_KEY] : null;
      if (stored !== OFFER_PROGRAM) {
        var err = new Error('/cart/update.js did not store ' + OFFER_ATTRIBUTE_KEY);
        err.stage = 'cart_attributes'; err.cart_endpoint = '/cart/update.js';
        throw err;
      }
      return cart;
    }

    var CART_RETRIES = 3;
    // The recheck runs after the button is released, so it gets one retry, not three.
    var CART_RECHECK_RETRIES = 1;
    // Every attempt runs under a deadline that covers the headers and the body: a
    // request Shopify never answers, or a body that never finishes, would otherwise
    // hold the button in its loading state for good, because nothing rejects.
    var CART_REQUEST_TIMEOUT_MS = 12000;
    // The shared add (cart-add-merge.js smartAdd) makes up to two cart requests of its
    // own with no deadline, then refreshes and opens the drawer; the whole add runs
    // under one deadline sized for that.
    var CART_ADD_DEADLINE_MS = CART_REQUEST_TIMEOUT_MS * 2 + 2000;
    function pause(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
    function timeoutError(label, ms, stage) {
      var e = new Error((label || 'cart request') + ' timed out after ' + ms + 'ms');
      e.stage = stage;
      e.timeout = true;
      return e;
    }
    function withDeadline(promise, ms, stage, label) {
      var timer;
      var deadline = new Promise(function (_, reject) {
        timer = setTimeout(function () { reject(timeoutError(label, ms, stage)); }, ms);
      });
      return Promise.race([promise, deadline]).then(
        function (value) { clearTimeout(timer); return value; },
        function (err) { clearTimeout(timer); throw err; }
      );
    }
    function cartRetryDelay(attempt) { return Math.min(800 * Math.pow(2, attempt), 3200) + Math.floor(Math.random() * 300); }
    function retryAfterMs(res) {
      var header = res && res.headers && typeof res.headers.get === 'function' ? res.headers.get('Retry-After') : null;
      if (!header) return null;
      var secs = Number(header);
      if (isFinite(secs)) return Math.min(Math.max(secs, 0) * 1000, 15000);
      var when = Date.parse(header);
      if (!isNaN(when)) return Math.min(Math.max(when - Date.now(), 0), 15000);
      return null;
    }
    // Requests a cart endpoint and returns its JSON body. A 429, a 5xx, a dropped
    // connection, an attempt past the deadline and an unreadable body are all retried
    // up to `retries` times (CART_RETRIES unless given); anything else, and the last
    // failure, throws with stage, cart_endpoint and http_status for the failure reporter.
    async function cartFetch(path, init, stage, retries) {
      var budget = retries == null ? CART_RETRIES : retries;
      for (var attempt = 0; ; attempt++) {
        // One deadline per attempt. Aborting the controller rejects a body read in
        // flight as well; without AbortController the deadline still rejects here,
        // and the request itself runs on unobserved.
        var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = null;
        var res = null;
        var body;
        try {
          var request = fetch(path, Object.assign({ credentials: 'same-origin' }, init, ctrl ? { signal: ctrl.signal } : {}))
            .then(function (r) { res = r; return r.ok ? r.json() : null; });
          if (ctrl) timer = setTimeout(function () { ctrl.abort(); }, CART_REQUEST_TIMEOUT_MS);
          body = await (ctrl ? request : withDeadline(request, CART_REQUEST_TIMEOUT_MS, stage, path));
        } catch (caught) {
          if (timer) clearTimeout(timer);
          var err = ctrl && ctrl.signal.aborted ? timeoutError(path, CART_REQUEST_TIMEOUT_MS, stage) : caught;
          if (attempt >= budget) {
            if (err && typeof err === 'object') { err.stage = stage; err.cart_endpoint = path; }
            throw err;
          }
          await pause(cartRetryDelay(attempt));
          continue;
        }
        if (timer) clearTimeout(timer);
        if (res.ok) return body;
        if ((res.status === 429 || res.status >= 500) && attempt < budget) {
          var ra = retryAfterMs(res);
          await pause(ra != null ? ra : cartRetryDelay(attempt));
          continue;
        }
        var e = new Error(path + ' ' + res.status);
        e.stage = stage;
        e.http_status = res.status;
        e.cart_endpoint = path;
        throw e;
      }
    }

    // One box per cart: a second tap must not become quantity 2. Same guard the PDP
    // upgrade runs before its add (PdpBuyColumn.jsx removeExistingCartBundles): every
    // bundle already in the cart, main lines and gifts, goes out before the Brewzle
    // bundle is added, so a repeat tap or a leftover quiz box never leaves two boxes,
    // and unrelated items stay. The removal is one /cart/update.js call keyed by line
    // item key, the same request cart-bundle-sync.js makes when a bundle main is
    // deleted, so there is no half-removed bundle to reconcile. Returns true when
    // something was removed.
    async function removeExistingBundles() {
      // Cannot see the cart, cannot know what is in it: the tap fails and the shopper
      // tries again, rather than clearing the cart to be sure (Labor Day's
      // 2026-09-05 fix: a cleared cart on a transient read failure threw away
      // unrelated merchandise). The error carries its stage and the submit handler
      // reports it once.
      var cart = await cartFetch('/cart.js', { headers: { Accept: 'application/json' } }, 'cart_verify');
      var updates = {};
      var count = 0;
      (Array.isArray(cart && cart.items) ? cart.items : []).forEach(function (item) {
        var bundleId = bundleIdOf(item);
        if (bundleId && item.key) { updates[item.key] = 0; count++; }
      });
      if (!count) return false;
      await cartFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }, 'cart_remove_existing');
      return true;
    }

    function bundleIdOf(item) {
      var props = item && item.properties;
      return props && typeof props._bundleId === 'string' ? props._bundleId.trim() : '';
    }
    // Bundle ids end in the tap's timestamp (tier_<ms>); the id itself breaks a tie.
    function bundleTs(id) {
      var m = /_(\d+)$/.exec(id || '');
      return m ? Number(m[1]) : 0;
    }
    function newerBundle(a, b) {
      if (b === null) return true;
      var ta = bundleTs(a);
      var tb = bundleTs(b);
      return ta > tb || (ta === tb && a > b);
    }

    // The add is not atomic across tabs: two tabs can each see an empty cart and add a
    // box, and cart-add-merge.js can fold an add into a same-tier main it did see (the
    // fold bumps that main's quantity and writes none of this tap's properties, so this
    // tap's bundle id lands on no line at all). One read after the add repairs both
    // outcomes: of the bundles actually in the cart the newest stays, every other one
    // goes out by key, and a kept main above quantity 1 goes back to 1. Runs after the
    // button is released, on one retry; a failure is reported (stage cart_recheck) and
    // never undoes the add.
    async function recheckCart(bundleId) {
      var result = { checked: false, bundle_id: bundleId, kept_bundle_id: null, own_bundle_kept: false, duplicates_removed: 0, quantity_fixed: 0 };
      try {
        var cart = await cartFetch('/cart.js', { headers: { Accept: 'application/json' } }, 'cart_recheck', CART_RECHECK_RETRIES);
        var items = Array.isArray(cart && cart.items) ? cart.items : [];
        var newest = null;
        items.forEach(function (item) {
          var id = bundleIdOf(item);
          if (id && newerBundle(id, newest)) newest = id;
        });
        var updates = {};
        var others = {};
        var fixed = 0;
        var changes = 0;
        items.forEach(function (item) {
          var id = bundleIdOf(item);
          if (!id || !item.key) return;
          if (id !== newest) { updates[item.key] = 0; others[id] = true; changes++; return; }
          var role = item.properties && typeof item.properties._role === 'string' ? item.properties._role.trim().toLowerCase() : '';
          if (role === 'main' && item.quantity > 1) { updates[item.key] = 1; fixed++; changes++; }
        });
        result.checked = true;
        result.kept_bundle_id = newest;
        result.own_bundle_kept = newest !== null && newest === bundleId;
        if (changes) {
          var repaired = await cartFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }, 'cart_recheck', CART_RECHECK_RETRIES);
          result.duplicates_removed = Object.keys(others).length;
          result.quantity_fixed = fixed;
          // The drawer and the badge were rendered from the add's own response before
          // this ran; refresh them the way cart-bundle-sync.js does after its removals.
          refreshCartUI(repaired);
        }
      } catch (err) {
        // Not paged (Labor Day's 2026-09-08 decision): the add already succeeded and
        // the shopper has the box, so a failed read here is a device network drop, not
        // a lost sale. The brewzle_bundle_recheck event with checked: false and the
        // error below is the record; a real Shopify outage still pages from the add.
        result.checked = false;
        result.error_message = String(err && err.message ? err.message : err || 'Unknown cart failure').slice(0, 200);
        result.error_kind = err && err.timeout ? 'timeout' : 'network';
        try { console.warn('[bz-offer] cart recheck failed:', result.error_message); } catch (e) {}
      }
      announce('recheck', result);
      return result;
    }
    function refreshCartUI(cart) {
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      } catch (e) {}
      var count = Number(cart && cart.item_count);
      if (!isFinite(count) || count < 0) return;
      document.querySelectorAll('cart-count').forEach(function (el) {
        el.innerText = String(count);
        el.hidden = count === 0;
      });
    }

    // smartAdd cannot cancel a Shopify mutation after its outer deadline wins.
    // A late response can therefore arrive after the shopper retries. Recheck
    // twice after a timed-out add; bundle timestamps make a newer retry win.
    function scheduleLateAddRechecks(bundleId) {
      [15000, 45000].forEach(function (delay) {
        setTimeout(function run() {
          if (inFlight || recheckInFlight) {
            setTimeout(run, 2000);
            return;
          }
          recheckInFlight = recheckCart(bundleId).then(
            function () { recheckInFlight = null; },
            function () { recheckInFlight = null; }
          );
        }, delay);
      });
    }

    // Disabling the focused button drops focus to the document in most browsers, and a
    // label change inside a disabled button is not announced, so the loading state is
    // mirrored into a visually hidden status region and focus goes back to the button
    // when nothing else took it (the cart drawer takes it on a successful add).
    var ctaHadFocus = false;
    function setLoading(isLoading) {
      if (!cta) return;
      if (!form) {
        cta.disabled = true;
        return;
      }
      if (isLoading) {
        ctaHadFocus = document.activeElement === cta;
        cta.disabled = true;
        cta.setAttribute('aria-busy', 'true');
        if (ctaLabel) ctaLabel.textContent = 'Preparing your cart…';
        if (ctaStatus) ctaStatus.textContent = 'Preparing your cart';
      } else {
        cta.disabled = false;
        cta.removeAttribute('aria-busy');
        if (ctaLabel) ctaLabel.innerHTML = originalLabel;
        if (ctaStatus) ctaStatus.textContent = '';
        if (ctaHadFocus && (!document.activeElement || document.activeElement === document.body)) {
          try { cta.focus({ preventScroll: true }); } catch (e) {}
        }
        ctaHadFocus = false;
      }
    }
    // A back/forward-cache restore mid-add must not re-enable the button while the
    // add is still running: two overlapping adds merge into one main line at quantity 2.
    var inFlight = false;
    window.addEventListener('pageshow', function () { if (!inFlight) setLoading(false); });
    window.addEventListener('pagehide', function () { if (!inFlight) setLoading(false); });

    function reportFailure(err) {
      var msg = err && err.message ? err.message : String(err || 'Unknown cart failure');
      if (window.WhiskyCartFailure && typeof window.WhiskyCartFailure.report === 'function') {
        window.WhiskyCartFailure.report({
          source: 'brewzle_offer',
          stage: (err && err.stage) || (window.WhiskyCartFailure.inferStage ? window.WhiskyCartFailure.inferStage(msg) : 'unknown'),
          error_message: msg,
          // Forwarded so the reporter never has to guess the endpoint from the stage.
          cart_endpoint: (err && err.cart_endpoint) || undefined,
          http_status: err && err.http_status != null ? err.http_status : undefined,
          error_kind: err && err.timeout ? 'timeout' : undefined,
          // One report per failed add: the reporter's interceptor drops its own copy.
          _reportToken: err && err._reportToken ? err._reportToken : undefined,
          tier_key: root.getAttribute('data-tier-key') || '',
          funnel_mode: 'open_drawer',
        });
      }
    }

    if (form && cta) {
      // A recheck still running from the previous tap; the next tap waits for it so
      // the two never write to the cart at the same time.
      var recheckInFlight = null;
      // The section's inline latch holds the native submit until this attribute
      // is set. Until 2026-09-21 this script was inline and the window between
      // the button existing and this listener binding was a few milliseconds;
      // as a deferred asset it is the whole parse plus a fetch. This form is a
      // real Shopify product form, so an unguarded tap in that window POSTs
      // /cart/add with the bare variant, no bundle, no tier, no offer markers,
      // and navigates away. Set it before the listener so there is no gap.
      root.setAttribute('data-bz-ready', '1');
      form.addEventListener('submit', async function (e) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (cta.disabled || inFlight) return;
        inFlight = true;
        if (ctaError) { ctaError.hidden = true; ctaError.textContent = ''; }
        setLoading(true);
        var bundleId = null;
        var added = false;
        var addReportToken = null;
        try {
          if (recheckInFlight) await recheckInFlight;
          var items = await fetchTierItems();
          // Same shape as the PDP upgrade's bundle id (tier key + timestamp), so the order
          // line reads like a PDP upsell order.
          bundleId = (root.getAttribute('data-tier-key') || 'pdp-explorer') + '_' + Date.now();
          var replaced = await removeExistingBundles();
          var bundled = items.map(function (item) {
            var role = item._role;
            var flatDiscount = item.flatDiscount;
            var rest = Object.assign({}, item);
            delete rest._role;
            delete rest.flatDiscount;
            var p = Object.assign({}, rest.properties || {}, {
              _bundleId: bundleId,
              _role: role || 'main',
              _offerProgram: OFFER_PROGRAM,
              _milestoneProgram: MILESTONE_PROGRAM,
              _milestoneTier: MILESTONE_TIER
            });
            if ((role || '').trim().toLowerCase() === 'gift' && flatDiscount != null && flatDiscount !== '') {
              p._flatDiscount = String(flatDiscount).trim();
            }
            if ((role || 'main').trim().toLowerCase() === 'main') {
              p._offer_source = OFFER_SOURCE;
              // Collection pin for the sweep — one barrel drawn at box-build time from
              // this Shopify collection (highest stock; first in collection order on a tie).
              if (PINNED_COLLECTION) p._pinned_collection = PINNED_COLLECTION;
            }
            rest.properties = p;
            return rest;
          });
          // The shared add has no deadline of its own, so it runs under one here. If the
          // deadline fires the add may still land later; the shopper sees the retry
          // message, and the next tap's removal takes any landed box out before adding.
          // The deadline's own error has no token, so the add's token is made here and
          // copied onto whatever this tap reports; the reporter then counts one failure
          // whether the section or its interceptor reports first.
          addReportToken = {};
          await withDeadline(
            window.CartBundleAdd && typeof window.CartBundleAdd.smartAdd === 'function'
              ? window.CartBundleAdd.smartAdd(bundled, { reportToken: addReportToken })
              : addItemsToCart(bundled, addReportToken),
            CART_ADD_DEADLINE_MS, 'cart_add', 'bundle add'
          );
          added = true;
          // Order-level marker for renewals, after the add and before the button is released.
          var attributeOk = false;
          var attributeError = '';
          if (ctaStatus) ctaStatus.textContent = 'Saving your order details';
          try {
            await withDeadline(stampOfferAttribute(bundleId), ATTRIBUTE_DEADLINE_MS, 'cart_attributes', 'offer attribute');
            attributeOk = true;
          } catch (attrErr) {
            attributeError = String(attrErr && attrErr.message ? attrErr.message : attrErr || 'unknown').slice(0, 160);
            if (window.console) console.warn('[Brewzle offer] order attribute not stamped:', attributeError);
          }
          announce('attribute', { bundle_id: bundleId, ok: attributeOk, error_message: attributeError || null });
          announce('added', { bundle_id: bundleId, item_count: bundled.length, replaced: replaced, order_attribute: attributeOk });
        } catch (err) {
          if (window.console) console.error('[Brewzle offer] bundle add failed:', err);
          if (err && typeof err === 'object' && !err._reportToken && addReportToken) {
            err._reportToken = addReportToken;
          }
          reportFailure(err);
          announce('add-failed', {
            stage: (err && err.stage) || (window.WhiskyCartFailure && window.WhiskyCartFailure.inferStage ? window.WhiskyCartFailure.inferStage(err && err.message ? err.message : '') : 'unknown'),
            error_message: String(err && err.message ? err.message : err || 'Unknown cart failure').slice(0, 200)
          });
          if (ctaError) {
            // Shown first, then filled, so the alert region announces the new text.
            ctaError.hidden = false;
            ctaError.textContent = 'We could not add the box to your cart. Please try again.';
          }
          if (err && err.timeout && err.stage === 'cart_add' && bundleId) {
            scheduleLateAddRechecks(bundleId);
          }
        } finally {
          inFlight = false;
          setLoading(false);
        }
        // After the button is released: the shopper has the box and the drawer is open,
        // so a slow recheck cannot hold the CTA. Tracked so the next tap waits for it.
        if (added) {
          recheckInFlight = recheckCart(bundleId).then(
            function () { recheckInFlight = null; },
            function () { recheckInFlight = null; }
          );
        }
      }, true);
    }

    /* ---------- Gallery ----------
       Thumbnails swap the main image, and the stage advances on its own so a visitor who
       never touches it still sees all six cards. It holds while the pointer is inside the
       gallery, while focus is inside it, after a tap, while the section is off screen or
       the tab is hidden, and it never runs under prefers-reduced-motion. */
    var gallery = root.querySelector('[data-bz-gallery]');
    if (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-bz-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-bz-thumb]'));
      if (slides.length > 1) {
        var galleryIndex = 0;
        var galleryTimer = null;
        var galleryHeld = false;
        var galleryOnScreen = true;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var interval = parseInt(gallery.getAttribute('data-bz-gallery-interval'), 10);
        if (!interval || interval < 1500) interval = 5000;

        function showSlide(next, fromUser) {
          if (next === galleryIndex || next < 0 || next >= slides.length) return;
          galleryIndex = next;
          slides.forEach(function (slide, i) {
            var on = i === next;
            slide.classList.toggle('is-active', on);
            if (on) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
            // A lazy slide that is about to show should not fade in blank.
            if (on && slide.getAttribute('loading') === 'lazy') slide.setAttribute('loading', 'eager');
          });
          thumbs.forEach(function (thumb, i) {
            var on = i === next;
            thumb.classList.toggle('is-active', on);
            thumb.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          if (fromUser) {
            announce('gallery-slide-selected', { index: next });
          }
        }

        function galleryTick() {
          if (galleryHeld || !galleryOnScreen || document.hidden) return;
          showSlide((galleryIndex + 1) % slides.length, false);
        }
        function startGallery() {
          if (reduceMotion || galleryTimer) return;
          galleryTimer = window.setInterval(galleryTick, interval);
        }
        function stopGallery() {
          if (!galleryTimer) return;
          window.clearInterval(galleryTimer);
          galleryTimer = null;
        }
        function hold(on) {
          galleryHeld = on;
          // Restart the clock on release so a held gallery does not jump the moment
          // the pointer leaves.
          if (!on) { stopGallery(); startGallery(); }
        }

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            showSlide(parseInt(thumb.getAttribute('data-bz-thumb'), 10) || 0, true);
            hold(false);
          });
        });

        gallery.addEventListener('pointerenter', function () { hold(true); });
        gallery.addEventListener('pointerleave', function () { hold(false); });
        gallery.addEventListener('focusin', function () { hold(true); });
        gallery.addEventListener('focusout', function (e) {
          if (!gallery.contains(e.relatedTarget)) hold(false);
        });
        gallery.addEventListener('touchstart', function () { hold(true); }, { passive: true });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { stopGallery(); } else { startGallery(); }
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) { galleryOnScreen = entry.isIntersecting; });
          }, { threshold: 0.25 }).observe(gallery);
        }

        // Left/right arrows move between thumbnails, the tablist convention.
        gallery.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          var current = thumbs.indexOf(document.activeElement);
          if (current < 0) return;
          e.preventDefault();
          var next = (current + (e.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
          thumbs[next].focus();
          showSlide(next, true);
        });

        startGallery();
      }
    }

    /* ---------- Accordions ---------- */
    root.querySelectorAll('.bz-acc__header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.bz-acc');
        if (!item) return;
        // One panel open at a time.
        root.querySelectorAll('.bz-acc.is-open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var b = other.querySelector('.bz-acc__header');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- Sticky bar: visible whenever no buy button is on screen ---------- */
    var sticky = root.querySelector('[data-bz-sticky]');
    var stickyAnchors = [];
    document.querySelectorAll('[data-bz-hero-cta], [data-bz-cta="hero"]').forEach(function (el) { stickyAnchors.push(el); });
    if (cta) stickyAnchors.push(cta);
    if (sticky && stickyAnchors.length && 'IntersectionObserver' in window) {
      var anchorVisible = new Map();
      function renderSticky() {
        var anyVisible = false;
        anchorVisible.forEach(function (v) { if (v) anyVisible = true; });
        var show = !anyVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // A hidden button (offer closed) never counts as visible.
          var shown = entry.isIntersecting && entry.target.offsetParent !== null;
          anchorVisible.set(entry.target, shown);
        });
        renderSticky();
      }, { threshold: 0 });
      stickyAnchors.forEach(function (el) { anchorVisible.set(el, false); io.observe(el); });
      var stickyCta = sticky.querySelector('[data-bz-cta="sticky"]');
      if (stickyCta) {
        stickyCta.addEventListener('click', function (e) {
          // Bring the real buy button itself into view, not just the top of the
          // card: on a tall buy box the card can be on screen with the button
          // still below the fold, and scrolling to the card top did nothing.
          // This never adds to the cart itself: a double tap while the bar is
          // sliding away must not turn into a purchase. It lands the visitor on the
          // buy button and hands it focus, and the tap on that button does the rest.
          var target = (cta && cta.offsetParent !== null) ? cta : document.getElementById('offer-box');
          if (!target) return;
          e.preventDefault();
          var r = target.getBoundingClientRect();
          // Land on the top of the plan card with the buy button still on screen:
          // card top when the card fits above the button, otherwise as far down as
          // it takes to keep the button just above the bottom edge.
          var card = root.querySelector('.bz-offer__plan') || document.getElementById('offer-box') || target;
          var cardTop = card.getBoundingClientRect().top + window.pageYOffset - 12;
          // The bar itself is still on screen for the 250ms it takes to slide away, so
          // keep the button above the bar, not just above the viewport edge.
          var barHeight = sticky.offsetHeight || 0;
          var buttonBottom = r.bottom + window.pageYOffset + 16 + barHeight - window.innerHeight;
          // An instant jump on purpose: a smooth scroll started from this handler is
          // cancelled by the browser as the bar hides, and the page stayed put.
          window.scrollTo(0, Math.max(0, cardTop, buttonBottom));
          if (typeof target.focus === 'function') {
            try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
          }
        });
      }
    }
    }
  })();
